export default "/img/BH.56fc005d7b1724f80c437525f873e9c4.png";